import React, { useEffect, useState, useRef } from 'react';
import './PhoneInput.css';

// const PhoneInputSelect = ({ 
  
//   label, 
//   options, 
//   defaultOption='', 
//   type='',
//   defaultValue = '', 
//   onChange, 
//   iconType, 
//   onSelectChange,  
//   className = '',
//   border='', 
//   error,
//   validators = [], 
//   readOnly = false,
//   disabled = false,

//   }) => {
//   const [value, setValue] = useState(defaultValue);
//   const [selectedOption, setSelectedOption] = useState(defaultOption);
//   const [errors, setErrors] = useState([]);


//     const validatorArray = Array.isArray(validators) 
//     ? validators 
//     : (validators ? [validators] : []);

//     const validateInput = (inputValue) => {
//       const newErrors = validatorArray
//         .map((validator) => {
//           if (typeof validator === 'function') {
//             const result = validator(inputValue);
//             return result === true ? null : result;
//           }
//           return null;
//         })
//         .filter((error) => typeof error === 'string');

//       return newErrors;
//     };

//     const handleInputChange = (event) => {
//       const newValue = event.target.value;
      
//       // Validate input
//       const newErrors = validateInput(newValue);
      
//       // Update state
//       setValue(newValue);
//       setErrors(newErrors);
  
//       if (onChange) {
//         onChange(event);
//       }
//     };

//   useEffect(() =>{
//       setValue(defaultValue);  
//     },[defaultValue])

//   useEffect(() =>{
//       setSelectedOption(defaultOption);
//   },[defaultOption])  

//   const handleSelectChange = (event) => {
//     setSelectedOption(event.target.value);
//     if (onSelectChange) {
//       onSelectChange(event);  // Passing the entire event object
//     }
//   };

//   const displayErrors = error ? [error] : errors;

//   const renderIcon = () => {
//     if (iconType === 'mobile') {
//       return (
//         <svg className='phone-input-svg' width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M8.5 0H1.5C0.675 0 0 0.675 0 1.5V14.5C0 15.325 0.675 16 1.5 16H8.5C9.325 16 10 15.325 10 14.5V1.5C10 0.675 9.325 0 8.5 0ZM3 0.75H7V1.25H3V0.75ZM5 15C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13C5.26522 13 5.51957 13.1054 5.70711 13.2929C5.89464 13.4804 6 13.7348 6 14C6 14.2652 5.89464 14.5196 5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15ZM9 12H1V2H9V12Z" fill="#424242"/>
//         </svg>
//       );
//     } else if (iconType === 'phone') {
//       return (
//         <svg className='phone-input-svg' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
//           <path d="M15.314 10.9631L11.4576 9.23485C11.2828 9.15998 11.0922 9.12988 10.9029 9.14727C10.7136 9.16466 10.5316 9.22899 10.3734 9.33444C10.3574 9.34479 10.3422 9.35625 10.3277 9.36873L8.31215 11.0831C8.29124 11.0945 8.26796 11.1009 8.24415 11.1017C8.22035 11.1026 8.19667 11.0979 8.175 11.088C6.87944 10.4626 5.53735 9.12872 4.90958 7.85112C4.89912 7.82978 4.89369 7.80632 4.89369 7.78255C4.89369 7.75878 4.89912 7.73532 4.90958 7.71398L6.62964 5.67308C6.642 5.658 6.65345 5.64219 6.66393 5.62574C6.76792 5.46696 6.83074 5.28478 6.8467 5.09565C6.86266 4.90652 6.83127 4.71639 6.75536 4.54243L5.03938 0.692496C4.94193 0.465229 4.7734 0.275699 4.55908 0.152349C4.34477 0.0289999 4.09623 -0.021514 3.85076 0.00838887C2.78397 0.148636 1.80474 0.672526 1.09607 1.48216C0.387396 2.29179 -0.00222676 3.33176 9.57372e-06 4.40773C9.57372e-06 10.7998 5.2002 16 11.5923 16C12.6682 16.0021 13.7081 15.6124 14.5177 14.9037C15.3273 14.1951 15.8512 13.216 15.9916 12.1492C16.0215 11.9049 15.9716 11.6575 15.8495 11.4438C15.7275 11.2301 15.5396 11.0615 15.314 10.9631ZM11.5923 15.0204C5.74063 15.0204 0.979637 10.2594 0.979637 4.40773C0.976908 3.57009 1.27924 2.76011 1.83015 2.12913C2.38107 1.49814 3.14286 1.08932 3.97322 0.979036H3.99199C4.02489 0.979651 4.05683 0.99019 4.08364 1.00927C4.11044 1.02836 4.13086 1.05509 4.1422 1.08598L5.86471 4.93183C5.87454 4.95322 5.87962 4.97647 5.87962 5C5.87962 5.02353 5.87454 5.04678 5.86471 5.06816L4.14139 7.11395C4.12859 7.12861 4.11686 7.14416 4.10628 7.16049C3.99845 7.32511 3.93494 7.51479 3.92193 7.71116C3.90892 7.90753 3.94683 8.10393 4.03199 8.28134C4.7561 9.76385 6.25003 11.2463 7.74886 11.9705C7.92732 12.0552 8.12467 12.0922 8.32169 12.0778C8.5187 12.0635 8.70864 11.9984 8.87299 11.8888C8.8885 11.8782 8.90401 11.8668 8.9187 11.8545L10.9335 10.1402C10.9534 10.1295 10.9753 10.1232 10.9979 10.1218C11.0204 10.1204 11.043 10.1239 11.0641 10.132L14.9214 11.8602C14.9529 11.8737 14.9794 11.8967 14.9971 11.926C15.0148 11.9553 15.0229 11.9894 15.0202 12.0235C14.9105 12.8543 14.502 13.6166 13.8712 14.1681C13.2403 14.7197 12.4302 15.0226 11.5923 15.0204Z" fill="#6D6D6D"/>
//         </svg>
//       );
//     }
//     return null; // Return null if no icon type matches
//   };

//   return (
//     <div className={`small-input-box-container ${border} phone-input-container  posrel ${displayErrors.length > 0 ? 'input-error' : ''} ${className} `}>
//       {renderIcon()}
//       <div className="phone-input-select posrel">
//         <select
//           value={selectedOption}
//           onChange={handleSelectChange}
//           className='fts-15 ftw-4 phone-select-box'
//           disabled={disabled}
//         >
//           {options.map((option, index) => (
//             <option className='fts-13' key={index} value={option.value}>{option.label}</option>
//           ))}
//         </select>
//         <svg className='custom-arrow-phone' width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
//           <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
//         </svg>
//       </div>
//       <input
//         className={`phone-input-box common-text fts-13 `}
//         type={type}
//         value={value}
//         onChange={handleInputChange}
//         placeholder=' '
//         readOnly={readOnly}
//       />
//       <label className={`phone-input-label fts-15 common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
//       {type !== 'small' && displayErrors.length > 0 && (
//         <div className="input-error-message fts-12 red currency-error">
//         {displayErrors[0]}
//         </div>
//       )}
//     </div>
//   );
// };

// export default PhoneInputSelect;





const PhoneInputSelect = ({ 
  
  label, 
  options, 
  defaultOption='', 
  type='',
  defaultValue = '', 
  onChange, 
  iconType, 
  onSelectChange,  
  className = '',
  border='', 
  error,
  validators = [], 
  readOnly = false,
  disabled = false,

  }) => {
  const [value, setValue] = useState(defaultValue);
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [errors, setErrors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [selectedValue, setSelectedValue] = useState(''); // Store the value to display

  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

    const validatorArray = Array.isArray(validators) 
    ? validators 
    : (validators ? [validators] : []);

    const validateInput = (inputValue) => {
      const newErrors = validatorArray
        .map((validator) => {
          if (typeof validator === 'function') {
            const result = validator(inputValue);
            return result === true ? null : result;
          }
          return null;
        })
        .filter((error) => typeof error === 'string');

      return newErrors;
    };

    const handleInputChange = (event) => {
      const newValue = event.target.value;
      
      // Validate input
      const newErrors = validateInput(newValue);
      
      // Update state
      setValue(newValue);
      setErrors(newErrors);
  
      if (onChange) {
        onChange(event);
      }
    };

  useEffect(() =>{
      setValue(defaultValue);  
    },[defaultValue])

    useEffect(() =>{
      console.log("grrrr",selectedValue);  
    },[selectedValue])

  useEffect(() =>{
      setSelectedOption(defaultOption);
      console.log("fed",defaultOption)
      // Find the option for the default value and store its LABEL for display (not value)
      const defaultOpt = options.find(opt => opt.value === defaultOption);
      setSelectedValue(defaultOpt?.label); // Changed from defaultOpt.value to defaultOpt.label
  },[defaultOption])  

  // Filter options based on search term
  useEffect(() => {
    if (searchTerm === '') {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase()) ||
        option.value.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  }, [searchTerm, options]);

  // Handle clicks outside dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectChange = (option) => {
    setSelectedOption(option.value);
    setSelectedValue(option.label); // Store the LABEL to display in the selected box (not value)
    setIsDropdownOpen(false);
    setSearchTerm('');
    
    if (onSelectChange) {
      // Create a synthetic event object similar to select change event
      const syntheticEvent = {
        target: {
          value: option.value // Send the ID as value for backend processing
        }
      };
      onSelectChange(syntheticEvent);
    }
  };


  const handleDropdownToggle = () => {
    if (disabled) return;
    setIsDropdownOpen(!isDropdownOpen);
    if (!isDropdownOpen && searchInputRef.current) {
      setTimeout(() => searchInputRef.current.focus(), 0);
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const displayErrors = error ? [error] : errors;

  const renderIcon = () => {
    if (iconType === 'mobile') {
      return (
        <svg className='phone-input-svg' width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.5 0H1.5C0.675 0 0 0.675 0 1.5V14.5C0 15.325 0.675 16 1.5 16H8.5C9.325 16 10 15.325 10 14.5V1.5C10 0.675 9.325 0 8.5 0ZM3 0.75H7V1.25H3V0.75ZM5 15C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13C5.26522 13 5.51957 13.1054 5.70711 13.2929C5.89464 13.4804 6 13.7348 6 14C6 14.2652 5.89464 14.5196 5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15ZM9 12H1V2H9V12Z" fill="#424242"/>
        </svg>
      );
    } else if (iconType === 'phone') {
      return (
        <svg className='phone-input-svg' xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M15.314 10.9631L11.4576 9.23485C11.2828 9.15998 11.0922 9.12988 10.9029 9.14727C10.7136 9.16466 10.5316 9.22899 10.3734 9.33444C10.3574 9.34479 10.3422 9.35625 10.3277 9.36873L8.31215 11.0831C8.29124 11.0945 8.26796 11.1009 8.24415 11.1017C8.22035 11.1026 8.19667 11.0979 8.175 11.088C6.87944 10.4626 5.53735 9.12872 4.90958 7.85112C4.89912 7.82978 4.89369 7.80632 4.89369 7.78255C4.89369 7.75878 4.89912 7.73532 4.90958 7.71398L6.62964 5.67308C6.642 5.658 6.65345 5.64219 6.66393 5.62574C6.76792 5.46696 6.83074 5.28478 6.8467 5.09565C6.86266 4.90652 6.83127 4.71639 6.75536 4.54243L5.03938 0.692496C4.94193 0.465229 4.7734 0.275699 4.55908 0.152349C4.34477 0.0289999 4.09623 -0.021514 3.85076 0.00838887C2.78397 0.148636 1.80474 0.672526 1.09607 1.48216C0.387396 2.29179 -0.00222676 3.33176 9.57372e-06 4.40773C9.57372e-06 10.7998 5.2002 16 11.5923 16C12.6682 16.0021 13.7081 15.6124 14.5177 14.9037C15.3273 14.1951 15.8512 13.216 15.9916 12.1492C16.0215 11.9049 15.9716 11.6575 15.8495 11.4438C15.7275 11.2301 15.5396 11.0615 15.314 10.9631ZM11.5923 15.0204C5.74063 15.0204 0.979637 10.2594 0.979637 4.40773C0.976908 3.57009 1.27924 2.76011 1.83015 2.12913C2.38107 1.49814 3.14286 1.08932 3.97322 0.979036H3.99199C4.02489 0.979651 4.05683 0.99019 4.08364 1.00927C4.11044 1.02836 4.13086 1.05509 4.1422 1.08598L5.86471 4.93183C5.87454 4.95322 5.87962 4.97647 5.87962 5C5.87962 5.02353 5.87454 5.04678 5.86471 5.06816L4.14139 7.11395C4.12859 7.12861 4.11686 7.14416 4.10628 7.16049C3.99845 7.32511 3.93494 7.51479 3.92193 7.71116C3.90892 7.90753 3.94683 8.10393 4.03199 8.28134C4.7561 9.76385 6.25003 11.2463 7.74886 11.9705C7.92732 12.0552 8.12467 12.0922 8.32169 12.0778C8.5187 12.0635 8.70864 11.9984 8.87299 11.8888C8.8885 11.8782 8.90401 11.8668 8.9187 11.8545L10.9335 10.1402C10.9534 10.1295 10.9753 10.1232 10.9979 10.1218C11.0204 10.1204 11.043 10.1239 11.0641 10.132L14.9214 11.8602C14.9529 11.8737 14.9794 11.8967 14.9971 11.926C15.0148 11.9553 15.0229 11.9894 15.0202 12.0235C14.9105 12.8543 14.502 13.6166 13.8712 14.1681C13.2403 14.7197 12.4302 15.0226 11.5923 15.0204Z" fill="#6D6D6D"/>
        </svg>
      );
    }
    return null; // Return null if no icon type matches
  };

  return (
    <div className={`small-input-box-container posrel ${displayErrors.length > 0 ? 'input-error' : ''} ${className} `}>
      {renderIcon()}
      <div className="phone-input-select blue-border posrel phone-with-search-page" ref={dropdownRef}>
        <div 
          className={`phone-select-box  fts-15 ftw-4 ${disabled ? 'phone-select-disabled' : ''} ${isDropdownOpen ? 'phone-select-open' : ''}`}
          onClick={handleDropdownToggle}
        >
          <span className="fts-13">{selectedValue}</span>
          <svg 
            className={`custom-arrow-phone ${isDropdownOpen ? 'phone-arrow-rotated' : ''}`} 
            width="8" 
            height="6" 
            viewBox="0 0 8 6" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
          </svg>
        </div>
        
        {isDropdownOpen && (
          <div className="phone-search-dropdown">
            <input
              ref={searchInputRef}
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="phone-search-input fts-13"
            />
            <div className="phone-options-list">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    className={`phone-option-item fts-13 ${selectedOption === option.value ? 'phone-option-selected' : ''}`}
                    onClick={() => handleSelectChange(option)}
                    onMouseEnter={(e) => {
                      if (selectedOption !== option.value) {
                        e.target.style.backgroundColor = '#f8f8f8';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedOption !== option.value) {
                        e.target.style.backgroundColor = 'white';
                      }
                    }}
                  >
                    {option.label}
                  </div>
                ))
              ) : (
                <div className="phone-no-options fts-13">
                  No options found
                </div>
              )}
            </div>
          </div>
        )}
              <input
        className={`phone-input-box common-text fts-15 `}
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder=' Enter phone'
        readOnly={readOnly}
      />
            <label className={`phone-input-label search-select-label fts-15 common-text ftw-4 color-999 has-value`}>{label}</label>

      </div>
      {type !== 'small' && displayErrors.length > 0 && (
        <div className="input-error-message fts-12 red currency-error">
        {displayErrors[0]}
        </div>
      )}

    </div>
  );
};

export default PhoneInputSelect;